import { ClientResponseError } from 'pocketbase';
import { useState, type FormEvent } from 'react';
import { login } from '../lib/auth';
import { APP_NAME } from '../lib/config';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email.trim(), password);
    } catch (err) {
      const status = err instanceof ClientResponseError ? err.status : 0;
      setError(
        status === 400
          ? 'E-Mail oder Passwort stimmt nicht.'
          : status === 0
            ? 'Keine Verbindung zum Server. Bist du online?'
            : 'Anmelden hat nicht geklappt. Versuch es nochmal.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <header>
        <h1>{APP_NAME}</h1>
      </header>
      <p>Melde dich an, um deine Wunschliste zu sehen.</p>
      <form onSubmit={submit} noValidate>
        <div className="field">
          <label htmlFor="l-email">E-Mail</label>
          <input
            id="l-email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="field">
          <label htmlFor="l-password">Passwort</label>
          <input
            id="l-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="err" role="alert">
          {error}
        </div>
        <button type="submit" className="btn ink" disabled={busy || !email || !password}>
          {busy ? 'Melde an…' : 'Anmelden'}
        </button>
      </form>
    </main>
  );
}
